import { createBrowserHistory } from "history";
import { applyMiddleware, createStore } from "redux";
import { routerMiddleware } from "connected-react-router";
import thunk from "redux-thunk";
import createRootReducer from "./app/reducers/index";
import logger from "redux-logger";
export const history = createBrowserHistory();

export default function configureStore(preloadedState) {
  let middleware = [routerMiddleware(history), thunk];
  if (process.env.NODE_ENV !== "production") {
    middleware = [...middleware, logger];
  }
  const store = createStore(
    createRootReducer(history), // root reducer with router state
    preloadedState,
    applyMiddleware(...middleware)
  );

  return store;
}
